import {useMemo} from 'react';

import {useViewBarContext} from '../NamedWorkspaceViewBarContext';
import {parseAndTrackNamedWorkspaces} from '../utils';

export const useUndoRedo = () => {
  const {viewer, currentView, undoWorkspaceAction, redoWorkspaceAction} =
    useViewBarContext();

  const undo = useMemo(
    () =>
      undoWorkspaceAction
        ? (isKeyboardShortcut: boolean) => {
            undoWorkspaceAction();
            parseAndTrackNamedWorkspaces({
              action: 'Undo',
              location: isKeyboardShortcut ? 'keyboard shortcut' : 'view bar',
              currentView,
              viewer,
            });
          }
        : null, // null means not allowed
    [currentView, undoWorkspaceAction, viewer]
  );

  const redo = useMemo(
    () =>
      redoWorkspaceAction
        ? (isKeyboardShortcut: boolean) => {
            redoWorkspaceAction();
            parseAndTrackNamedWorkspaces({
              action: 'Redo',
              location: isKeyboardShortcut ? 'keyboard shortcut' : 'view bar',
              currentView,
              viewer,
            });
          }
        : null, // null means not allowed
    [currentView, redoWorkspaceAction, viewer]
  );

  return useMemo(
    () => ({
      currentView,
      undo,
      redo,
    }),
    [currentView, undo, redo]
  );
};
